import React from 'react';
import { AvailableForPurchaseProduct } from '../../../../../interfaces/merchants/resources/books/index';

import css from './BookingPurchaseProductList.module.scss';

import BookingPurchaseProduct from './components/BookingPurchaseProduct';

type Props = {
  products: AvailableForPurchaseProduct[];
  merchantId: string;
};

export const BookingPurchaseProductList: React.FC<Props> = (props) => {
  const { products, merchantId } = props;

  return (
    <div>
      {products.map((product) => (
        <div className={css.listItem}>
          <BookingPurchaseProduct
            key={product.public_id}
            merchantId={merchantId}
            product={product}
          />
        </div>
      ))}
    </div>
  );
};
